const MAX_MESSAGE_LENGTH = 200;

// Backend error text is shown directly to anonymous passengers, so cap what
// gets surfaced: short, expected messages (e.g. "Feedback already submitted")
// pass through untouched, but anything unexpectedly long — a stack trace or
// other internal detail leaking through — falls back to a generic message
// instead of being rendered verbatim.
export function safeErrorMessage(error, fallback) {
  const message = error?.message;
  if (typeof message === 'string' && message.trim() && message.length <= MAX_MESSAGE_LENGTH) {
    return message;
  }
  return fallback;
}
